import React from "react";

function Linkedin(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="846.667"
      height="720"
      version="1"
      viewBox="0 0 635 540"
      className={props.class}
    >
      <path
        id={props.id1}
        d="M278 5376c-105-38-201-127-240-224l-23-57V345l23-57c31-76 105-156 184-199l63-34h4800l62 34c77 41 146 113 181 189l27 57v4770l-27 57c-35 76-109 153-183 192l-60 31-2385 2c-1945 2-2392 0-2422-11zm1051-735c84-26 137-59 202-128 63-66 89-111 114-197 23-77 16-199-14-278-96-249-387-368-624-255-294 139-358 521-126 747 119 115 295 159 448 111zm2538-1207c45-8 120-28 167-45 285-103 437-316 509-714 22-117 22-139 22-980V835h-790l-6 780c-5 710-7 785-23 840-28 93-66 162-113 206-65 60-121 81-235 87-223 11-360-58-438-223-64-137-64-135-70-950l-5-740h-790l-3 1278-2 1277h770v-355l27 40c135 202 357 342 590 374 84 12 280 4 390-15zM1598 2113l-3-1278H805l-3 1278-2 1277h800l-2-1277zM5813 695c-43-21-87-53-109-78-146-167-114-425 66-546 73-48 140-65 235-59 272 18 423 327 274 560-37 57-74 90-143 125-43 23-67 28-151 31-99 4-101 3-172-33zm290-28c74-34 131-88 164-155 24-48 28-70 28-137 0-66-5-90-27-137-117-250-466-252-588-3-34 68-35 197-4 266 77 166 266 240 427 166z"
        transform="matrix(.1 0 0 -.1 0 540)"
      ></path>
      <path
        id={props.id2}
        d="M5850 370V180h25c25 0 25 1 25 85v85h34c31 0 37-6 87-85 47-74 57-85 82-85 32 0 34-6-34 97l-48 71 27 7c65 16 96 83 68 148-20 48-45 57-167 57h-99V370zm202 133c10-9 18-30 18-49 0-47-29-64-107-64h-63v130h67c48 0 72-5 85-17z"
        transform="matrix(.1 0 0 -.1 0 540)"
      ></path>
    </svg>
  );
}

export default Linkedin;